// @flow
export const VENDING_ENABLED: 'vending_enabled' = 'vending_enabled';
export const VENDING_DISABLED: 'vending_disabled' = 'vending_disabled';
export const VENDING_READ_ONLY: 'vending_read_only' = 'vending_read_only';
